module.exports = __webpack_public_path__ + "img/EAST_YEARBOOK-35-min.f6345344.jpg";